import { Injectable, OnInit } from '@angular/core';
import * as io from 'socket.io-client';
import {environment} from '../environments/environment';
import { GlobalCfgService } from "./globalcfg.service";
import { Event } from "./socket-events";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LabelScanService implements OnInit{
  socket: any;
  appType: any = "selfcare";
  manufacturingPlant: any;

  constructor(
    private globalCfgService: GlobalCfgService
  ) { }

  ngOnInit() {}

  startReceiver() {
    this.socket = io(environment.aggregatorsocketUrl + "?type=" + this.appType + "&access_token=" + this.globalCfgService.getAccessToken() + "&location=" + JSON.stringify({
      gln: this.manufacturingPlant['gln'],
      name: this.manufacturingPlant['name']
    }));
    return this.socket;
  }

  public onEvent(event: Event): Observable<any> {
    return new Observable<Event>(observer => {
      this.socket.on(event, (data: any) => {
        console.log("Received " + event + " event from websocket service");
        observer.next(data);
      });
    });
  }
}
